import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";
import { useAuthStore } from "../..";
import styles from './AccountLink.module.css';

function AccountLink() {
    const authStore = useAuthStore();

    return (
        <Link to="/userSettings">
            <div className={styles.container}>
                {authStore.user?.firstName[0].toUpperCase()}{authStore.user?.lastName[0].toUpperCase()}
            </div>
        </Link>
    );
}

export default observer(AccountLink);